import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AIScribeUsageData } from 'src/app/shared/consult-forms/assessment-ai-scribe/assessment-ai-scribe.model';
import {
  AI_SCRIBE_ALL_SECTIONS,
  AIScribeSection,
  AiScribeSetup
} from './ai-scribe-setup.model';
import { ClinicSetupService } from '../clinic-setup.service';

@Component({
  selector: 'csi-ai-scribe-setup',
  templateUrl: './ai-scribe-setup.component.html',
  styleUrls: ['./ai-scribe-setup.component.scss']
})
export class AiScribeSetupComponent implements OnInit {
  public readonly aiScribeAllSections: AIScribeSection[] = (AI_SCRIBE_ALL_SECTIONS as unknown) as AIScribeSection[];
  public aiScribeUsage: AIScribeUsageData = null;
  public aiScribeUsageLoading = false;

  constructor(
    public clinicSetupService: ClinicSetupService,
    private changeRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.loadAIScribeUsage();
  }

  loadAIScribeUsage() {
    if (!this.clinicSetupService.clinicId) {
      return;
    }
    this.aiScribeUsageLoading = true;
    this.clinicSetupService.getAIScribeUsage().subscribe(
      usage => {
        this.aiScribeUsage = usage;
        this.aiScribeUsageLoading = false;
        this.changeRef.markForCheck();
      },
      () => {
        this.aiScribeUsageLoading = false;
      }
    );
  }

  onAiScribeToggle(enabled: boolean) {
    const current: AiScribeSetup = this.clinicSetupService.aiScribeSetup || {};

    // When enabling for the first time, default all sections except patientProfile
    const defaultSections =
      enabled && !(current.sections && current.sections.length)
        ? AI_SCRIBE_ALL_SECTIONS.filter(s => s !== 'patientProfile')
        : current.sections;

    const updated: AiScribeSetup = {
      ...current,
      enabled,
      sections: defaultSections
    };

    this.clinicSetupService
      .updateClinicSetup({
        id: this.clinicSetupService.clinicSetupId,
        aiScribeSetup: JSON.stringify(updated)
      })
      .subscribe(() => {
        this.clinicSetupService.aiScribeSetup = updated;
      });
  }

  get aiScribeEnabledSections(): string[] {
    const setup = this.clinicSetupService.aiScribeSetup;
    if (!setup || !setup.sections) {
      // Default: all sections EXCEPT patientProfile (for safety/privacy)
      return AI_SCRIBE_ALL_SECTIONS.filter(s => s !== 'patientProfile');
    }
    return setup.sections;
  }

  isAiScribeSectionEnabled(section: string): boolean {
    return this.aiScribeEnabledSections.indexOf(section) !== -1;
  }

  onAiScribeSectionToggle(section: string, enabled: boolean) {
    const current = this.aiScribeEnabledSections;
    const updated: AiScribeSetup = {
      ...(this.clinicSetupService.aiScribeSetup || {}),
      sections: enabled
        ? current.indexOf(section) === -1 ? [...current, section] : current
        : current.filter(s => s !== section)
    };
    this.clinicSetupService
      .updateClinicSetup({
        id: this.clinicSetupService.clinicSetupId,
        aiScribeSetup: JSON.stringify(updated)
      })
      .subscribe(() => {
        this.clinicSetupService.aiScribeSetup = updated;
      });
  }
}
